export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    showDeleteModal: false,
    deletingItem: null,
    fields: [
      {
        key: 'name',
        label: 'Nome'
      },
      {
        key: 'isActive',
        label: 'Ativo'
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
